import { useEffect, useState } from 'react'
import { CIMSBasicFieldProps } from '../../../CIMSBasicFields/types'
import { useFoundCallback } from './useFoundCallback'
import { DateValue } from '../../types'
import { dateFormatter } from '../../../../utils/dateFormatter'

export function useDateCustomFields(
  textValues?: DateValue[]
): CIMSBasicFieldProps[] {
  const [fields, setFields] = useState<CIMSBasicFieldProps[]>([])
  const found = useFoundCallback()
  useEffect(() => {
    if (!textValues) return
    setFields(
      textValues.map(({ customFieldId, value, customField }) =>
        found({
          customField,
          customFieldId,
          children: (found) =>
            found?.metadata?.timestamp
              ? dateFormatter.shortDatetime(value)
              : dateFormatter.simple(value),
        })
      )
    )
  }, [found, textValues])
  return fields
}
